import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { Observable, Subscription } from "rxjs";
import { skip } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import {
  AppState,
  getLoadingPartyState,
  loadedCustomerPartyListState,
} from "src/app/store/reducers";
import { getCustomerPartyList } from "src/app/store/actions/parties/parties.actions";

import { AutocompleteSelectItem } from "src/app/models/selection-list/autocomplete-select-item.model";
import { FormUtils } from "../../utils/formUtils";

//Entity Search Form
export const FORM_PARAMS = {
  entity: "entity",
};

@Component({
  selector: "search-picker",
  templateUrl: "./search-picker.component.html",
  styleUrls: ["./search-picker.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SearchPickerComponent implements OnInit, OnDestroy {
  @Input() set entity(entity: string) {
    this._entity = entity;
  }

  @Output() selectEntity: EventEmitter<any> = new EventEmitter<any>();

  _entity: string;

  isLoadingEntities$: Observable<boolean>;
  entitiesList$: Observable<any[]>;
  entitiesList: AutocompleteSelectItem[] = [];
  entitiesSub: Subscription;
  searchTimer: number;

  searchEntityDataForm: FormGroup;

  constructor(private store: Store<AppState>, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.setSearchObservable();
    this.createSearchEntityForm();
    this.setEntitySearchSubscription();
  }

  setSearchObservable() {
    switch (this._entity) {
      case "customer":
        this.isLoadingEntities$ = this.store.pipe(select(getLoadingPartyState));
        this.entitiesList$ = this.store.pipe(
          select(loadedCustomerPartyListState)
        );
        break;
    }
  }

  createSearchEntityForm() {
    this.searchEntityDataForm = this.fb.group({
      [FORM_PARAMS.entity]: [
        null,
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          FormUtils.isObjectValidator,
        ],
      ],
    });
    this.onEntityChanges(this.searchEntityDataForm);
  }

  onEntityChanges(form: FormGroup): void {
    form.get(FORM_PARAMS.entity).valueChanges.subscribe((entity) => {
      this.selectEntity.emit(entity);
    });
  }

  setEntitySearchSubscription() {
    this.entitiesSub = this.entitiesList$
      .pipe(skip(1))
      .subscribe((entities) => {
        if (entities) {
          switch (this._entity) {
            case "customer":
              this.entitiesList = entities.map(
                ({ code, customerCode, name }) => {
                  return {
                    code: code,
                    displayCode: customerCode ?? "",
                    description: name ?? "",
                  };
                }
              );
              break;
          }
        }
      });
  }

  searchEntities(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);

    this.searchTimer = window.setTimeout(
      () => {
        switch (this._entity) {
          case "customer":
            this.store.dispatch(
              getCustomerPartyList({
                options: {
                  filteringArgs: {
                    filterConfig: [
                      { field: "customerCode" },
                      { field: "name" },
                    ],
                    searchTerms: [searchTerm],
                  },
                },
              })
            );
            break;
        }
      },
      hasTimer ? 500 : 0
    );
  }

  validateFirstEntitySearch() {
      this.searchEntities('');
  }

  displayEntity(entity: {
    code: string;
    displayCode: string;
    description: string;
  }): string {
    return entity?.description ?? "";
  }

  ngOnDestroy() {
    if (this.entitiesSub) {
      this.entitiesSub.unsubscribe();
    }
  }
}
